<template>
  <v-app>
    <toolbar @navigationDrawerClicked="$refs.navigation_drawer.toggleDrawer()"/>
    <navigation-drawer ref="navigation_drawer"/>

    <v-content>
      <router-view class="router-view"/>
    </v-content>

    <v-footer app class="justify-center">
      <v-btn text href="mailto:info@gloomhaventracker.com">Contact us</v-btn>
<!--      <v-btn text @click="$router.push({name: 'rules'})">Rules</v-btn>-->
<!--      <v-btn text @click="$router.push({name: 'gdpr'})">GDPR</v-btn>-->
    </v-footer>
  </v-app>
</template>

<script>
  import Toolbar from "./components/layout/Toolbar";
  import NavigationDrawer from "./components/layout/NavigationDrawer";

  export default {
    name: "App",

    components: {
      Toolbar,
      NavigationDrawer
    },

    watch: {
      '$route' (to) {
        document.title = (to.meta.title || 'Your Website') + " | Gloomhaven Tracker";
      }
    }
  };
</script>
